module.exports = __webpack_public_path__ + "static/media/KaTeX_Main-Italic.081073fd.woff";